<template>
  <div class="widget">
    <div class="widget-heading">
      <h2 class="textStyle">{{ $t("summary_sheet.title") }}</h2>
    </div>
    <div class="widget-content">
      <div v-for="summarySheet in questionnaire.summarySheetQuestionnaires" :key="summarySheet.id" class="summarySheet">
        <div class="summarySheet__heading">
          <div class="summarySheet__questionnaire">
            <div>
              {{ summarySheet.questionnaire.title }}
              <div v-if="summarySheet.field" class="summarySheet__question">- {{ summarySheet.field.title }}</div>
              <div v-if="summarySheet.cluster" class="summarySheet__question">- {{ summarySheet.cluster.title }}</div>
              <div class="summarySheet__profile">- {{ setProfileLabel(summarySheet.profile) }}</div>
            </div>
            <span>{{ $t("note.coefficient") }} : {{ summarySheet.coefficient }}</span>
          </div>
        </div>
        <div class="summarySheet__note">
          <span>{{ $tc("note.title", 1) }}</span>
          <span>{{ summarySheet.mark ? summarySheet.mark : "--" }}</span>
        </div>
      </div>
      <div class="globalNote">
        <span>{{ $t("summary_sheet.average") }}</span>
        <span>
          {{
            questionnaire.summarySheetMark && questionnaire.summarySheetMark[$route.params.triadId]
              ? questionnaire.summarySheetMark[$route.params.triadId]
              : "--"
          }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { usePlatformStore } from "@/store/platform/platform";
import { triadManager } from "@/services/triad/triad-manager";

export default {
  name: "QuestionnaireSummarySheetComponent",
  components: {},
  props: {
    questionnaire: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapState(usePlatformStore, {
      apprenticeProfileLabel: (store) => store.apprenticeProfileLabel,
      tutorProfileLabel: (store) => store.tutorProfileLabel,
      apprenticeMasterProfileLabel: (store) => store.apprenticeMasterProfileLabel,
      studeaManagerProfileLabel: (store) => store.studeaManagerProfileLabel,
    }),
  },
  methods: {
    setProfileLabel(key) {
      return triadManager.setProfileLabel(
        key,
        this.apprenticeProfileLabel,
        this.tutorProfileLabel,
        this.apprenticeMasterProfileLabel,
        this.studeaManagerProfileLabel,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.summarySheet {
  margin-bottom: 20px;

  &__heading {
    margin-bottom: 10px;
  }

  &__questionnaire {
    display: flex;
    justify-content: space-between;
    background-color: var(--primary-color);
    padding: 5px 10px;
    border-radius: 6px;
    color: #fff;
    margin-bottom: 5px;
    font-weight: 700;
  }

  &__question,
  &__profile {
    display: inline-block;
    font-weight: 400;
    padding-left: 5px;
  }

  &__note {
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
  }
}

.globalNote {
  border-top: 1px dashed #e0e6ed;
  font-weight: 700;
  padding: 10px 10px 0 10px;
  display: flex;
  justify-content: space-between;
}
</style>
